import { makeAutoObservable, flow } from 'mobx'

import * as srv from 'admin/services'
import handleError from 'admin/services/error-handler'

export default class CustomerStore {
  loading = false
  processing = false
  openDialog = false
  selected = null
  list = []
  total = 0
  query = {
    phoneNumber: '',
    sortBy: 'updatedAt',
    sortDirection: 'desc',
  }
  currentPage = 0
  rowsPerPage = 10

  DEFAULT = {
    id: 0,
    prestoId: 0,
    driverId: 0,
    originalData: {},
  }

  constructor(rootStore) {
    makeAutoObservable(this, {
      reload: flow,
      fetchOne: flow,
      fetch: flow,
      fetchTotal: flow,
      fetchAddress: flow,
    })
    this.rootStore = rootStore
  }

  setSelected = (value) => {
    this.selected = value
  }

  updateQuery = (key, value, resetPage = false) => {
    this.query[key] = value
    if (resetPage) this.currentPage = 0
  }

  resetQuery = () => {
    this.query = {
      phoneNumber: '',
    }
  }

  updatePage = (page) => {
    this.currentPage = page
  }

  updateRowsPerPage = (perPage) => {
    this.rowsPerPage = perPage
  }

  get queryParams() {
    const params = {
      sortBy: this.query.sortBy,
      sortDirection: this.query.sortDirection,
      limit: this.rowsPerPage,
      offset: this.currentPage * this.rowsPerPage,
    }
    if (this.query.phoneNumber) params.phoneNumber = this.query.phoneNumber
    return params
  }

  * reload(reset = false) {
    yield this.fetch()
    if (reset) {
      this.selected = { ...this.DEFAULT }
    }
  }

  * fetchOne(params) {
    try {
      this.loading = true
      const response = yield srv.searchCustomer(params)
      if (response.ok) return response.data
      throw handleError(response)
    } catch (error) {
      return error
    } finally {
      this.loading = false
    }
  }

  * fetch(params) {
    try {
      this.loading = true
      const response = yield srv.fetchCustomer({
        ...this.queryParams,
        ...params,
      })
      if (response.ok) {
        this.list = response.data.list
        this.total = response.data.total
        return response.data
      }
      throw handleError(response)
    } catch (error) {
      return null
    } finally {
      this.loading = false
    }
  }

  * fetchTotal(params) {
    try {
      this.loading = true
      const response = yield srv.fetchTotalCustomer({
        ...params,
      })
      if (response.ok) {
        this.total = response.data.total
        return response.data
      }
      throw handleError(response)
    } catch (error) {
      return null
    } finally {
      this.loading = false
    }
  }

  * fetchAddress(params) {
    try {
      this.loading = true
      const response = yield srv.fetchCustomerAddress(params)
      if (response.ok) return response.data.address
      throw handleError(response)
    } catch (error) {
      return null
    } finally {
      this.loading = false
    }
  }
}
